import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { forwardRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLoading } from "../../../providers/loadingProvider";
import {
  committeeSelector,
  committeesSelector,
  setCommittee,
} from "../../../store/advisorSlice";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
}));

export default function CommitteesSelector({ ...rest }) {
  const committees = useSelector(committeesSelector);
  const committee = useSelector(committeeSelector);
  const [selectedCommittee, setselectedCommittee] = useState(
    committee?.committeeId
  );
  const loading = useLoading();
  const dispatch = useDispatch();

  const classes = useStyles();
  useEffect(() => {
    setselectedCommittee(committee?.committeeId);
  }, [committee?.committeeId]);

  const CommitteeChanged = (e) => {
    const lid = loading.addLoading("loading committee");
    var committeeId = e.target.value;
    var newCommittee = committees.filter(
      (c) => c.committeeId === committeeId
    )[0];
    dispatch(setCommittee(newCommittee));
    loading.removeLoading(lid);
  };

  const Committees = forwardRef((props, ref) => (
    <FormControl
      {...props}
      ref={ref}
      className={classes.formControl}
      size="small"
    >
      <Select
        value={selectedCommittee}
        onChange={CommitteeChanged}
        id="applicant"
      >
        {committees.map((c) => (
          <MenuItem key={c.committeeId} value={c.committeeId}>
            {c.committeeName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ));

  const Committee = forwardRef((props, ref) => (
    <Box {...props} ref={ref} fontSize={18} fontWeight={500}>
      {committees[0].committeeName}
    </Box>
  ));

  return (
    <Box {...rest} style={{display:"flex"}}>
      <Typography style={{marginRight:10, marginTop:1, fontSize:17}}>Panel:</Typography>
      {committees?.length === 1 ? <Committee /> : <Committees />}
    </Box>
  );
}
